import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpMainService } from '../http-main.service';
import {
  BankCardResponseModel,
  ListModel,
  CardBankRequestModel,
} from '@itb-monorepo/models';

interface CardListParams {
  skip: number;
  take: number;
}

@Injectable()
export class CardsService {
  baseUrl = '/finance/';
  private _HttpMainService = inject(HttpMainService);

  addOrEdit(
    model: CardBankRequestModel,
    cardId?: string
  ): Observable<BankCardResponseModel> {
    if (cardId) {
      return this._HttpMainService.put(
        `${this.baseUrl}v1/cards/${cardId}`,
        model
      );
    }

    return this._HttpMainService.post(this.baseUrl + 'v1/cards', model);
  }

  listCard(
    status: string,
    params?: CardListParams
  ): Observable<ListModel<BankCardResponseModel>> {
    const qParams = {
      filter: `status:in(${status})`,
      sort: 'desc(created_at)',
      ...(params ?? {}),
    };

    return this._HttpMainService.get(this.baseUrl + 'v1/cards', qParams);
  }

  get(id: string): Observable<BankCardResponseModel> {
    return this._HttpMainService.get(this.baseUrl + 'v1/cards/' + id);
  }

  getByCardNumber(
    userId: string,
    number: string
  ): Observable<BankCardResponseModel> {
    return this._HttpMainService.get(
      this.baseUrl + `v1/users/${userId}/cards/` + number
    );
  }
}
